module.exports = __webpack_public_path__ + "assets/img/kv-db45d426.jpg";